import React from 'react';
import { Award, Star, MessageSquare, Sparkles, TrendingUp, Zap } from 'lucide-react';
interface TopPick {
  id: string;
  name: string;
  by: string;
  description: string;
  rating: number;
  ratingCount: string;
  category: string;
  conversations: string;
  url: string;
  conversationStarters?: string[];
  rank?: string;
  featured?: boolean;
}
const TOP_PICKS: TopPick[] = [{
  id: 'chatgpt-shopping-assistance',
  name: 'ChatGPT Shopping Assistance',
  by: 'OpenAI',
  description: "🔥 The world's most powerful AI shopping assistant! Get instant product recommendations, compare prices across thousands of stores, find the best deals, and make confident purchase decisions. From electronics to fashion, groceries to gifts - ChatGPT helps you shop smarter, faster, and better. Trusted by millions worldwide!",
  rating: 5.0,
  ratingCount: '1B+',
  category: 'Lifestyle',
  conversations: '700M+',
  url: 'https://chatgpt.com/?hints=shopping+research&openaicom_referred=true',
  conversationStarters: ['Find me the best laptop under $1000 for video editing', 'Compare iPhone 15 Pro vs Samsung Galaxy S24 Ultra', "What's the best air fryer for a family of 4?", 'Help me find a gift for my tech-savvy dad under $200'],
  featured: true
}, {
  id: 'shopping-gpt',
  name: 'Shopping GPT',
  by: 'awesomegpts.ai',
  description: 'Shop Smarter, Save Bigger! Quickly find top-rated gems and the best deals in the shopping sea!',
  rating: 3.5,
  ratingCount: '800+',
  category: 'Lifestyle',
  conversations: '50K+',
  url: 'https://chatgpt.com/g/g-nleealfRT-shopping-gpt',
  conversationStarters: ['Compare MacBook series products in a table', 'Locate nearby headphone retailers', 'Find sofas with top reviews', 'Find the cheapest Apple Watch Series 9']
}, {
  id: 'fashion-assistant',
  name: 'Fashion Assistant | Outfit | Shopping | Budget',
  by: 'orbixai.com',
  description: '🔴Upload a photo or provide a description & get fashion tips.🔴 Personalized Style Recommendations, Celebrity Style Matching, Smart Savings, Event Outfit Planning, Color Palette Suggestions, Sustainable Fashion Options & more!',
  rating: 4.1,
  ratingCount: '500+',
  category: 'Lifestyle',
  conversations: '100K+',
  url: 'https://chatgpt.com/g/g-GOxEy4j5K-fashion-assistant-outfit-shopping-budget'
}, {
  id: 'kayak',
  name: 'KAYAK - Flights, Hotels & Cars',
  by: 'kayak.com',
  description: 'Your travel planning assistant for flights, hotels, & cars',
  rating: 3.8,
  ratingCount: '5K+',
  category: 'Lifestyle',
  conversations: '600K+',
  url: 'https://chatgpt.com/g/g-hcqdAuSMv-kayak-flights-hotels-cars',
  rank: '#12 in Lifestyle (EN)'
}, {
  id: 'shopping-assistant',
  name: 'Shopping Assistant',
  by: 'madhu r',
  description: 'A helpful shopping assistant for finding and comparing products.',
  rating: 4.0,
  ratingCount: '30+',
  category: 'Lifestyle',
  conversations: '1K+',
  url: 'https://chatgpt.com/g/g-JquynUdeg-shopping-assistant'
}, {
  id: 'ai-coupon-finder',
  name: 'AI Coupon Code Finder: Smart Shopping Companion',
  by: 'community builder',
  description: "Efficiently find the best online deals with our AI Coupon Finder. Quick, user-friendly, and updated in real-time, it's the ideal tool for savvy shoppers looking to save big effortlessly. Free and easy to use.",
  rating: 3.0,
  ratingCount: '20+',
  category: 'Lifestyle',
  conversations: '5K+',
  url: 'https://chatgpt.com/g/g-23B7QDQzF-ai-coupon-code-finder-smart-shopping-companion'
}, {
  id: 'shopping-buddy',
  name: 'Shopping Buddy',
  by: 'talkingcart.com',
  description: "I help you find products on Amazon In the USA and Canada. If you're in Canada, let me know so I search amazon.ca",
  rating: 4.0,
  ratingCount: '30+',
  category: 'Productivity',
  conversations: '1K+',
  url: 'https://chatgpt.com/g/g-0LCaXfcXj-shopping-buddy'
}];
function StarRating({
  rating
}: {
  rating: number;
}) {
  return <div className="flex items-center gap-1" data-id="element-294">
      {[1, 2, 3, 4, 5].map(star => <Star key={star} size={14} className={star <= Math.round(rating) ? 'fill-yellow-400 text-yellow-400' : 'fill-slate-200 text-slate-200'} data-id="element-295" />)}
    </div>;
}
export function TopPicks() {
  return <div className="mb-16" data-id="element-296">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6" data-id="element-297">
        <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-purple-500 to-pink-500 grid place-items-center" data-id="element-298">
          <Award size={20} className="text-white" data-id="element-299" />
        </div>
        <div data-id="element-300">
          <h2 className="text-2xl font-bold" data-id="element-301">Top Shopping GPTs</h2>
          <p className="text-sm text-slate-600" data-id="element-302">
            Most popular AI shopping assistants from the GPT Store
          </p>
        </div>
      </div>

      {/* Grid */}
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-303">
        {TOP_PICKS.map(pick => <div key={pick.id} className={`group rounded-2xl bg-white shadow-sm hover:shadow-md transition-all p-5 flex flex-col ${pick.featured ? 'border-2 border-gradient-to-r from-purple-500 to-pink-500 ring-2 ring-purple-200 relative' : 'border border-slate-200 hover:border-slate-300'}`} data-id="element-304">
            {/* Featured Badge */}
            {pick.featured && <div className="absolute -top-3 left-1/2 -translate-x-1/2" data-id="element-305">
                <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 text-white text-xs font-bold shadow-lg" data-id="element-306">
                  <Zap size={14} className="fill-white" data-id="element-307" />
                  FEATURED - MOST POPULAR
                </div>
              </div>}

            {/* Header */}
            <div className="mb-3 mt-2" data-id="element-308">
              <h3 className={`font-bold text-lg mb-1 line-clamp-2 leading-tight ${pick.featured ? 'text-purple-900' : 'text-slate-900'}`} data-id="element-309">
                {pick.name}
              </h3>
              <p className="text-xs text-slate-500" data-id="element-310">By {pick.by}</p>
            </div>

            {/* Description */}
            <p className={`text-sm leading-relaxed mb-4 flex-1 ${pick.featured ? 'line-clamp-4 text-slate-800 font-medium' : 'line-clamp-3 text-slate-700'}`} data-id="element-311">
              {pick.description}
            </p>

            {/* Stats */}
            <div className="space-y-2 mb-4 pb-4 border-b border-slate-100" data-id="element-312">
              <div className="flex items-center justify-between" data-id="element-313">
                <div className="flex items-center gap-2" data-id="element-314">
                  <StarRating rating={pick.rating} data-id="element-315" />
                  <span className={`text-sm font-semibold ${pick.featured ? 'text-purple-900' : 'text-slate-900'}`} data-id="element-316">
                    {pick.rating}
                  </span>
                </div>
                <span className="text-xs text-slate-500" data-id="element-317">
                  Ratings ({pick.ratingCount})
                </span>
              </div>

              <div className="flex items-center justify-between text-sm" data-id="element-318">
                <div className="flex items-center gap-1.5" data-id="element-319">
                  <span className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${pick.featured ? 'bg-purple-100 text-purple-700' : 'bg-slate-100 text-slate-700'}`} data-id="element-320">
                    {pick.category}
                  </span>
                </div>
                <div className={`flex items-center gap-1 ${pick.featured ? 'text-purple-700 font-semibold' : 'text-slate-600'}`} data-id="element-321">
                  <MessageSquare size={14} data-id="element-322" />
                  <span className="text-xs font-semibold" data-id="element-323">
                    {pick.conversations}
                  </span>
                </div>
              </div>

              {/* Rank Badge */}
              {pick.rank && <div className="flex items-center gap-1.5 pt-1" data-id="element-324">
                  <TrendingUp size={14} className="text-orange-500" data-id="element-325" />
                  <span className="text-xs font-semibold text-orange-600" data-id="element-326">
                    {pick.rank}
                  </span>
                </div>}
            </div>

            {/* Conversation Starters */}
            {pick.conversationStarters && <div className="mb-4" data-id="element-327">
                <p className={`text-xs font-semibold mb-2 flex items-center gap-1 ${pick.featured ? 'text-purple-700' : 'text-slate-600'}`} data-id="element-328">
                  <Sparkles size={12} data-id="element-329" />
                  Conversation Starters
                </p>
                <div className="space-y-1.5" data-id="element-330">
                  {pick.conversationStarters.slice(0, 2).map((starter, idx) => <div key={idx} className={`text-xs rounded-lg px-2.5 py-1.5 line-clamp-1 ${pick.featured ? 'bg-purple-50 text-purple-800 border border-purple-200' : 'bg-slate-50 text-slate-600'}`} data-id="element-331">
                      {starter}
                    </div>)}
                </div>
              </div>}

            {/* CTA */}
            <a href={pick.url} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center w-full rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors ${pick.featured ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:from-purple-700 hover:to-pink-700 shadow-md hover:shadow-lg' : 'bg-slate-900 text-white hover:bg-black'}`} data-id="element-332">
              {pick.featured ? 'Try ChatGPT Shopping Now ↗' : 'Open in GPT Store ↗'}
            </a>
          </div>)}
      </div>
    </div>;
}